// API for the Assistant Usage page (Admin): how people use the Node Mobile
// assistant and Siri, and what they ask for that it can't do yet. Server:
// server/routes/api/Assistant/assistantUsageHandler.js (read-only over the
// mobile server's users.assistant_logs). Every call identifies the caller by
// the x-user-id header, like the other admin pages.

export const ASSISTANT_USAGE_ROLES = ["Admin"];

const request = async (url, userId) => {
  const res = await fetch(url, {
    headers: { Accept: "application/json", "x-user-id": userId || "" },
  });
  let content = {};
  try {
    content = await res.json();
  } catch (e) {
    // Non-JSON error page (e.g. the server is restarting).
  }
  if (!res.ok) throw new Error(content.error || "Request failed");
  return content;
};

// days: 7 | 30 | 90 | "all"
// → { days, since, truncated, totals, byDay, commands, people, unsupported }
export const fetchAssistantUsage = (userId, days = 30) =>
  request(`/api/assistant-usage?days=${encodeURIComponent(days)}`, userId);

// filter: all | siri | unsupported | nothing | problems. `before` = the last
// row's `at`, for the next page. → { requests, hasMore }
export const fetchAssistantRequests = (userId, { days = 30, filter = "all", q = "", before } = {}) => {
  const params = new URLSearchParams({ days: String(days), filter });
  if (q.trim()) params.set("q", q.trim());
  if (before) params.set("before", before);
  return request(`/api/assistant-usage/requests?${params}`, userId);
};

// The assistant's command (tool) names, in the words people would use.
// Mirrors server/src/assistant/*.js in the NodeMobileV2 repo; a new command
// shows its raw name until it's added here.
export const COMMAND_LABELS = {
  training_my_assignments: "Training due",
  safety_concern_prepare: "Safety Concern",
  truck_inspection_status: "Truck pre-trip status",
  trucks_needing_inspection: "Trucks needing a pre-trip",
  truck_start_inspection: "Start a pre-trip",
  list_truck: "List Truck",
  order_status: "Order status",
  order_find_by_customer: "Find an order by customer",
  order_open: "Open an order",
  order_problem_prepare: "Order Problem",
  website_list_online_users: "Who's on the website",
  website_find_user: "Where someone is on the website",
  website_send_user_to_page: "Send someone to a page",
  assistant_confirm_pending: "Said yes to submit",
  assistant_cancel_pending: "Said no to submit",
  assistant_note_unsupported: "Couldn't do it",
};

export const commandLabel = (name) => COMMAND_LABELS[name] || name;

export const SUBMITTED_LABELS = {
  order_problem: "Order Problem",
  safety_concern: "Safety Concern",
};
